import styled, { keyframes } from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const ellipsis = keyframes(["0%,20%{content:'.';}40%{content:'..';}60%,100%{content:'...';}"]);
const Text = styled.span.withConfig({
  displayName: "VoiceTranscribingBar__Text"
})(["flex:1;min-width:0;height:26px;display:flex;align-items:center;font-size:14px;line-height:20px;font-weight:400;color:#141414;&::after{content:'...';animation:", " 1.2s steps(1) infinite;}"], ellipsis);
const VoiceTranscribingBar = () => /*#__PURE__*/_jsx(Text, {
  role: "status",
  children: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "conversations-visitor-ui.voiceInput.transcribing"
  })
});
VoiceTranscribingBar.displayName = 'VoiceTranscribingBar';
export default VoiceTranscribingBar;